import { render, staticRenderFns } from "./RomaMessageModal.vue?vue&type=template&id=28c8effa"
import script from "./RomaMessageModal.vue?vue&type=script&lang=ts"
export * from "./RomaMessageModal.vue?vue&type=script&lang=ts"
import style0 from "./RomaMessageModal.vue?vue&type=style&index=0&id=28c8effa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports